import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { IndiaAIFestivalContact } from "../components/IndiaAIFestival";
import { useTranslation } from "react-i18next";
import {
  ATLTinckerpreneurTarget,
  ATLTinckerpreneurObjective,
  ATLTinkerpreneurBanner,
  ATLTinkerpreneurGuidelines,
  ATLTinkerpreneurTimeline,
  ATLTinckerpreneurDisclaimer,
} from "../components/ATLTinckerpreneur";
import { LanguageSwitcher } from "../components/shared";
import { isRegistrationOpen } from "../utils/tinkerpreneur";

const Section = styled.div`
  margin-top: 35px;

  @media (min-width: 992px) {
    margin-top: 55px;
  }
`;

const Box = styled.div`
  font-size: 18px !important;
  color: #000 !important;
  border: 3px solid #ff8f4e;
  border-radius: 10px;

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

const IndiaAITinkerpreneurPage2025 = () => {
  const token = localStorage.getItem("jwtToken");
  const [timelineData, setTimelineData] = useState([]);
  const year = 2025;
  const { t } = useTranslation();

  const fetchWorkshopData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/`,
        {
          headers: {
            "x-access-token": token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setTimelineData(data.workshops);
      return data.workshops;
    } catch (error) {
      console.error("Failed to fetch timeline data", error);
    }
  };

  const handleEnroll = async (event) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/enroll`, {
        method: "POST",
        headers: {
          "x-access-token": token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ event_id: event._id }),
      });
      await fetchWorkshopData();
    } catch (error) {
      console.error("Enrollment failed", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (localStorage.getItem("jwtToken")) {
        await fetchWorkshopData();
      }
    };
    init();
  }, []);

  return (
    <>
      {/* {isRegistrationOpen(year) &&
        localStorage.getItem("showTinkerpreneurPopUp") === null &&
        (
          <ATLTinkerpreneurPopUp year={year} />
        )} */}

      <div className="gray-light-bg">
        <div className="container d-flex justify-content-end">
          <LanguageSwitcher />
        </div>
        <div className="blog-container shadow px-0 pt-0 mt-0">
          <div className="mar-t-15">
            <ATLTinkerpreneurBanner year={year} />
          </div>
          <Section className="px-md-2 px-xl-5 mx-auto">
            <ATLTinckerpreneurObjective />
          </Section>
          <Section>
            <ATLTinckerpreneurTarget />
          </Section>
          {timelineData.length > 0 && (
            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinkerpreneurTimeline
                key={timelineData.length}
                events={timelineData}
                handleEnroll={handleEnroll}
              />
            </Section>
          )}
          <div className="container">
            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinkerpreneurGuidelines year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinckerpreneurDisclaimer />
            </Section>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndiaAITinkerpreneurPage2025;
